export const electronicsData = {
  departmentName: "Department of Electronics & Communication Engineering",
  bannerImage: "/infrastructure/ece/banner.jpg",

  about: {
    title: "About the Department",
    content: `The Department of Electronics & Communication Engineering at Rayalaseema University is committed to 
    providing quality education in the rapidly evolving field of electronics and communication. Our curriculum 
    encompasses analog and digital electronics, signal processing, communication systems, VLSI design, and embedded 
    systems. We focus on both theoretical knowledge and practical skills to prepare students for successful careers 
    in the electronics and telecommunication industries.`,
    highlights: [
      "State-of-the-art electronics and communication laboratories",
      "Industry-sponsored projects and internships",
      "Research focus on VLSI, IoT, and wireless communication",
      "Strong industry partnerships and placement record"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/electronics/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    id:'ece001',
    name: "B.A.SARATH MANOHAR BABU ",
    designation: "Co-ordinator & Assistant Professor (AD HOC)",
    photo: "/ece/sarath.JPG",
    email: "Hod.ece@ruce.ac.in",
    mobile: "+91 7013644322",
    qualification: "B.Tech(ECE), M.Tech(DECS) ",
    specialization: " Embedded & IoT",
    message: `Welcome to the Department of Electronics & Communication Engineering. We are dedicated to excellence 
    in electronics education and research, preparing students to become innovative engineers who can contribute to 
    technological advancement in the communication and electronics industries.`,
    profileLink: "/ece/sarath.pdf"
  },

  bos: {
    title: "Board of Studies",
    members: [
      // {
      //   name: "Prof. Narasimha Rao",
      //   designation: "Chairman",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Usha Rani",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Satish Kumar",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Prof. External Expert",
      //   designation: "External Member",
      //   affiliation: "Industry Partner"
      // }
    ]
  },

  faculty: [
    {
      id:'ece001',
      name: "B.A.SARATH MANOHAR BABU ",
      designation: "Co-ordinator & Assistant Professor (AD HOC)",
      photo: "/ece/sarath.JPG",
      email: "Hod.ece@ruce.ac.in",
      mobile: "+91 7013644322",
      qualification: "B.Tech(ECE), M.Tech(DECS),(Ph.D.) ",
      specialization: " Embedded & IoT",
      profileLink: "/ece/sarath.pdf"
    },
    {
      id:'ece002',
      name: "MOHAMMED ABDUL FARIDA ",
      designation: "Assistant Professor (AD HOC)",
      email: "mafarida01.ece@ruce.ac.in",
      mobile: "+91 9885448606",
      photo: "/ece/farida.JPG",
      qualification: "B.Tech, M.Tech., (Ph.D.)",
      specialization: "VLSI-SD ",
      profileLink: "/ece/farida.pdf"
    },
    {
      id:'ece003',
      name: "DR.K.VANITHA",
      designation: "Assistant Professor (AD HOC)",
      email: "vanitha09.ece@ruce.ac.in ",
      mobile: "+91 6304313644 ",
      photo: "/ece/vineetha.JPG",
      qualification: "B.Tech, M.Tech., Ph.D.",
      specialization: "BIOMEDICAL IMAGE PROCESSING",
      profileLink: "/ece/vineetha.pdf"
    }
  ],

  courses: {
    undergraduate: [
      {
        name: "B.Tech Electronics & Communication Engineering",
        duration: "4 Years",
        eligibility: "10+2 with Physics, Chemistry, and Mathematics",
        intake: "120 seats"
      }
    ]
  },

  Infrastructure: [
    "/infrastructure/ece/class-1.JPG",
    "/infrastructure/ece/class-2.JPG",
    "/infrastructure/ece/class-3.JPG"
  ]
};
